/**
 * The three pages Data curation replaced (M286 idea 16) redirect to their tab, so old links and bookmarks keep
 * working: /settings/reference-data#reference-section-<key> keeps its hash, and /settings/property-types-uses?tab=<id>
 * (Property Types' own tab) becomes ?tab=types&sub=<id>.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { DATA_CURATION_PATH, PROPERTY_TYPES_TAB_PARAM, type DataCurationTabId } from '@/components/settings/settingsTabs';

/** Where an old URL lands: Data curation on `tab` (the first tab has no param). */
export function dataCurationTarget(tab: DataCurationTabId, search: string, hash: string): string {
  const params = new URLSearchParams();
  if (tab !== 'lookups') params.set('tab', tab);
  const inner = new URLSearchParams(search).get('tab');
  if (tab === 'types' && inner) params.set(PROPERTY_TYPES_TAB_PARAM, inner);
  const query = params.toString();
  return `${DATA_CURATION_PATH}${query ? `?${query}` : ''}${hash}`;
}

export function DataCurationRedirect({ tab }: { tab: DataCurationTabId }) {
  const { search, hash } = useLocation();
  return <Navigate to={dataCurationTarget(tab, search, hash)} replace />;
}
